import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericHttp } from './generic-http.service';
import { Config } from '@config/config.service';
import { ValidationRulesApiData } from '@features/profile/product-validation/product-validation.interface';

@Injectable()
export class ValidationRulesApiService {
  private validationRulesUrl: string;
  private validationRulesSearchUrl: string;
  private dataListUrl: string;

  constructor(
    private trbhttp: GenericHttp,
    private config: Config,
  ) {
    this.validationRulesUrl = config.validationRulesUrl;
    this.validationRulesSearchUrl = config.validationRulesSearchUrl;
    this.dataListUrl = config.dataListUrl;
  }

  createValidationRules(data: ValidationRulesApiData): Observable<any> {
    return this.trbhttp.post(this.validationRulesUrl, data);
  }

  getDatalist(): Observable<any> {
    return this.trbhttp.get(this.dataListUrl);
  }

  updateValidationRules(ruleId: string, data: ValidationRulesApiData): Observable<any> {
    const url = `${this.validationRulesUrl}/${ruleId}`;

    return this.trbhttp.put(url, data);
  }

  getAllValidationRules(): Observable<any> {
    return this.trbhttp.get(this.validationRulesUrl);
  }

  getValidationRule(id): Observable<any> {
    const url = `${this.validationRulesUrl}/${id}`;

    return this.trbhttp.get(url);
  }

  searchValidationData(productType, insuranceCompanies): Observable<any> {
    let companiesParams = '';

    insuranceCompanies.forEach(company => {
      companiesParams += `insuranceCompanies=${company}&`;
    });

    companiesParams = companiesParams.replace(/&$/, '');

    const url = `${this.validationRulesSearchUrl}?productType=${productType}&${companiesParams}`;

    return this.trbhttp.get(url);
  }
}
